//= =======================================================================================
/*
  children    [element]
  isRequired  [bool]    - added required prefix after block
 */
//= =======================================================================================


import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

const IBWrapper = styled.div`
  border-radius: 4px;
  background-color: ${(p) => p.theme.color.background};
  display: flex;
  @media all and (max-width: 576px) {
    margin-top: 10px;
  }
  svg {
    width: 24px;
    height: 24px;
    margin: .9em .9em 0 .9em;
  }
`;

const IBMessage = styled.div`
  margin: .9em .9em .9em 0;
  color: ${(p) => p.theme.color.label};
  font-size: 0.875em;
  .list-caption {
    color: ${(p) => p.theme.color.text};
  }
  ul {
    margin: .5em 0;
    padding-left: 1em;
    li {
      padding-left: 1em;
    }
  }
`;

const IBRequired = styled.p`
  font-size: 0.75rem;
  color: ${(p) => p.theme.color.label};
  margin-top: 0.625em;
  span  {
    color: ${(p) => p.theme.color.error};
  }
`;


const InformBlock = ({ children, isRequired, t }) => (
  <div className="inform-block">
    <IBWrapper>
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="#A2A4B2" fillRule="nonzero"
            d="M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-22C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm-1 13h2v3h-2v-3zm0-9h2v7h-2V6z" />
        </svg>
      </div>

      <IBMessage>
        {children}
      </IBMessage>
    </IBWrapper>

    {isRequired ? (
      <IBRequired>
        <span>* </span>
        {t('required')}
      </IBRequired>
    ) : null}

  </div>
);
InformBlock.propTypes = {
  children: PropTypes.node,
  isRequired: PropTypes.bool,
  t: PropTypes.func.isRequired,
};
InformBlock.defaultProps = {
  children: null,
  isRequired: false,
};

export default translate()(InformBlock);
